import React from "react";
import { CircuitBoard, FileText, MonitorDot, Settings, SubscriptIcon, UserRound, UsersRound } from "lucide-react";
import { RoutePath } from "routes/route-path";
import { BrandingData } from "admin-portal/settings/branding";

const adminMenuData: any = [
  {
    label: "menu",
    isTitle: true,
  },
  {
    id: "dashboard",
    label: "Dashboards",
    link: "/#",
    icon: <MonitorDot />,
    /* subItems: [
      {
        id: "analyticsdashboard",
        label: "Analytics",
        link: "/dashboards-analytics",
        parentId: "dashboard",
      },
      {
        id: "ecommercedashboard",
        label: "Ecommerce",
        link: "/dashboard",
        parentId: "dashboard",
      },
      {
        id: "emaildashboard",
        label: "Email",
        link: "/dashboards-email",
        parentId: "dashboard",
      },
      {
        id: "hrdashboard",
        label: "HR",
        link: "/dashboards-hr",
        parentId: "dashboard",
      },
      {
        id: "socialdashboard",
        label: "Social",
        link: "/dashboards-social",
        parentId: "dashboard",
      },
    ],*/
  },
  {
    label: "Apps",
    isTitle: true,
  },
  {
    id: "tenant-management",
    label: `${BrandingData.bussinessDomain} Management`,
    icon: <CircuitBoard />,
    parentId: "tenantmanagement",
    link: "/#",
    subItems: [
      {
        id: "tenant-list",
        label: `${BrandingData.bussinessDomain} List`,
        link: RoutePath.Admin_TenantList,
        parentId: "tenantmanagement",
      },
      {
        id: "tenant-onboard",
        label: `${BrandingData.bussinessDomain} Onborad`,
        link: RoutePath.Admin_TenantOnboard,
        parentId: "tenantmanagement",
      },
    ],
  },
  {
    id: "subscription-management",
    label: `Subscription`,
    icon: <SubscriptIcon />,
    parentId: "subscriptionManagement",
    link: "/#",
    subItems: [
      {
        id: "subscriptions",
        label: `Subscriptions`,
        link: RoutePath.Admin_Subscriptions,
        parentId: "subscriptionManagement",
      },
      {
        id: "manage-subscription",
        label: `Create subscription`,
        link: RoutePath.Admin_Subscription_new,
        parentId: "subscriptionManagement",
      },
    ],
  },
  {
    id: "setup-management",
    label: `Data Setup`,
    icon: <Settings />,
    parentId: "dataSetupManagement",
    link: "/#",
    subItems: [
      {
        id: "service-types",
        label: `Service Types`,
        link: RoutePath.Admin_ServiceTypes,
        parentId: "dataSetupManagement",
      },
      {
        id: "services",
        label: `Services`,
        link: RoutePath.Admin_Services,
        parentId: "dataSetupManagement",
      },
      {
        id: "vehicle-models",
        label: `Vehicle Models`,
        link: RoutePath.Admin_VehicleModels,
        parentId: "dataSetupManagement",
      },
    ],
  },
  /* {
    id: "employee-management",
    label: `Employee Management`,
    icon: <UsersRound />,
    parentId: "hrManagement",
    link: "/#",
    subItems: [
      {
        id: "byemployee",
        label: "By Employee",
        link: "/apps-hr-leave-employee",
        parentId: "hrManagement",
      },
      {
        id: "addleaveemployee",
        label: "Add Leave (Employee)",
        link: "/apps-hr-create-leave-employee",
        parentId: "hrManagement",
      },
      {
        id: "byhr",
        label: "By HR",
        link: "/apps-hr-leave",
        parentId: "hrManagement",
      },
      {
        id: "addleavehr",
        label: "Add Leave (HR)",
        link: "/apps-hr-create-leave",
        parentId: "hrManagement",
      },
    ],
  },
  {
    id: "invoice",
    label: "Invoices",
    icon: <FileText />,
    parentId: 2,
    subItems: [
      {
        id: "invoicelistview",
        label: "Listview",
        link: "/apps-invoice-list",
        parentId: "invoice",
      },
      {
        id: "invoiceaddnew",
        label: "Add New",
        link: "/apps-invoice-add-new",
        parentId: "invoice",
      },
      {
        id: "invoiceoverview",
        label: "Overview",
        link: "/apps-invoice-overview",
        parentId: "invoice",
      },
    ],
  },
  {
    id: "customers",
    label: "Customers",
    icon: <UserRound />,
    parentId: 2,
    subItems: [
      {
        id: "customerlistview",
        label: "List view",
        link: "/apps-customer-list",
        parentId: "customers",
      },
      {
        id: "customergridview",
        label: "Grid View",
        link: "/apps-customer-grid",
        parentId: "customers",
      },
    ],
  },*/
];

export { adminMenuData };
